/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

// Actions
import { setSelectedCreditType } from 'store/ducks/reports/actions';

// Constants
import SELLING_POINTS from 'constants/sellingPoints';

// Types
import { ApplicationState } from 'store';

// Styles
import useStyles from './creditType.styles';

const CreditTypeFilter: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const selectedCreditType = useSelector(
    (state: ApplicationState) => state.reports.selectedCreditType,
  );

  const handleChange = (token: any) => {
    const updated = [...selectedCreditType];

    const index = selectedCreditType.findIndex(({ key }) => key === token.KEY);

    if (index === -1) {
      updated.push({
        key: token?.KEY || 0,
        value: token?.VALUE || '',
      });
    } else updated.splice(index, 1);

    dispatch(
      setSelectedCreditType({
        selectedCreditType: updated,
      }),
    );
  };

  return (
    <FormControl component='fieldset' className={classes.formControl}>
      <FormLabel component='legend'>Selecione um ou mais status</FormLabel>
      <List dense>
        {SELLING_POINTS.TRANSACTION_TYPES.map((token) => (
          <ListItem key={token.KEY} button>
            <ListItemText
              primary={token.VALUE}
              onClick={() => handleChange(token)}
              classes={{ root: classes.itemText }}
            />
            <ListItemSecondaryAction>
              <Checkbox
                edge='end'
                color='primary'
                onClick={() => handleChange(token)}
                checked={
                  !!selectedCreditType.find(({ key }) => key === token.KEY)
                }
                inputProps={{ 'aria-labelledby': token.VALUE }}
              />
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </FormControl>
  );
};

export { CreditTypeFilter };
export default CreditTypeFilter;
